import { Typography } from '../../../components/typography/typography';
import { PaymentsReportV2 } from './payments-report-v2';

export const PaymentsReport = () => {
  return (
    <div className="order-list container-v2 pb-5">
      <div className="flex justify-between items-center">
        <Typography type="display-xs" weight="medium" className="text-[var(--grey-800)]">
          Payments
        </Typography>
      </div>
      <PaymentsReportV2 />
    </div>
  );
};
